<template>
    <div>
        <div id="create-campaign">
            <div class="app-container my-5" v-show="!$global.loading">

                <div class="page-title mb-3">
                    <router-link to="/campaigns">
                        <span class="breadcrumb-link">
                            <v-icon class="breadcrumb-link-icon">dashboard</v-icon> Campagnes
                        </span>
                    </router-link>
                    <v-icon>keyboard_arrow_right</v-icon>
                    <span class="breadcrumb-item" v-if="aspect && aspect !== ''">
                        <v-icon class="breadcrumb-item-icon">mdi-plus-circle</v-icon>
                       Création d'une Campagne Aspect - {{aspectLabel}}
                    </span>
                    <span class="breadcrumb-item" v-else>
                        <v-icon class="breadcrumb-item-icon">mdi-plus-circle</v-icon> Création d'une Campagne de
                        mise à jour
                    </span>
                </div>

                <v-text-field v-model="campaign.name" background-color="white" label="Nom de votre campagne" outlined>
                </v-text-field>

                <v-stepper @change="setCurrentStep" non-linear :value="currentStep">
                    <v-stepper-header>
                        <v-stepper-step editable step="1">
                            Sélection
                        </v-stepper-step>

                        <v-stepper-step editable step="2">
                            Validation prestataires
                        </v-stepper-step>

                        <v-stepper-step editable step="3">
                            Formulaire
                        </v-stepper-step>

                        <v-stepper-step editable step="4">
                            Contenu de l'e-mail
                        </v-stepper-step>

                        <v-stepper-step editable step="5">
                          Options
                        </v-stepper-step>

                        <v-stepper-step editable step="6">
                            Finaliser
                        </v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <filters :aspect="aspect"></filters>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                            <verification></verification>
                        </v-stepper-content>

                        <v-stepper-content step="3">
                            <information v-if="tabulations.length" :tabulations="tabulations" :select-all="true"
                                         :aspect="aspect">
                            </information>
                        </v-stepper-content>

                        <v-stepper-content step="4">
                            <email v-if="providers.length || selectedApidaeSelection"></email>
                        </v-stepper-content>

                        <v-stepper-content step="5">
                          <options :criterias="criterias" :is-revival="false"
                                   :hasSuggestionOption="hasSuggestionOption">
                          </options>
                        </v-stepper-content>

                        <v-stepper-content step="6">
                            <finalize :cmaj-name="campaign.name" :update-mode="false" :is-revival="false"
                                      :criterias="criterias" :hasSuggestionOption="hasSuggestionOption"
                                      :aspect="aspect">
                            </finalize>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </div>
        </div>
    </div>
</template>

<script>
import Filters from "@/components/campaign/cmaj/stepers/Filters"
import { mapMutations, mapState } from "vuex"
import Verification from "./stepers/Verification"
import Information from "./stepers/Information"
import Email from "./stepers/Email"
import Finalize from "./stepers/Finalize"
import Options from "./stepers/Options"
import { aspectElements } from "../../../static/webform"

export default {
    name: "CreateCampaignScratch",
    components: { Finalize, Email, Information, Verification, Filters, Options },
    data() {
        return {
            campaign: { name: null },
            tabulations: [],
            criterias: [],
            hasSuggestionOption: false,
            aspect: '',
        }
    },
    methods: {
        ...mapMutations('createCmaj', ['setCurrentStep', 'setFirstPartMail', 'setLastPartMail', 'setSender', 'resetState',
        'addEditedTabulation', "setTxtIntro", 'setTxtIntroAspect', 'setTxtIntroCmaj',]),
        getFields() {
            this.$http.get('auth/campaigns/cmaj/referential/fields').then(res => {
                this.tabulations = res.body.data.tabulations

                this.tabulations.forEach(tab => {
                    if(tab.help_description || tab.new_title) {
                        this.addEditedTabulation(tab)
                    }
                })
            })
        },
        initDefaultName() {
            let year = this.$moment().format('YYYY')

            if(!this.aspect) {
                this.campaign.name = 'Campagne de mise à jour ' + year
            } else {
                this.campaign.name = this.aspectLabel + ' ' + year
            }
        },
        initFirstPartEmail() {
            let text = "<p>Cher(e) partenaire,</p>" +
                "<p>Nous vous sollicitons pour mettre à jour vos informations diffusées sur notre site internet ainsi que dans nos points d'accueil. " +
                "Au moyen du questionnaire accessible via le bouton ci-dessous, nous vous invitons à mettre à jour vos informations afin de renseigner au mieux nos visiteurs.</p>"

            this.setFirstPartMail(text)
        },
        initLastPartEmail() {
            let text = "<p>Nous restons disponibles pour vous accompagner dans la mise à jour de vos informations.</p>"

            this.setLastPartMail(text)
        },
        getInternalCriterias() {
            this.$http.get('auth/account/apidae-criterias').then(res => {
                this.criterias = res.body.data.criterias
            })
        },
        getAccountIntroTxt() {
            let txtIntroAspect = null
            let txtIntro = null

            if(this.account.configurations.txtIntroAspect) {
                txtIntroAspect = this.account.configurations.txtIntroAspect.value
            }

            if(this.account.configurations.txtIntro) {
                txtIntro = this.account.configurations.txtIntro.value
            }

            if(this.aspect !== undefined && this.aspect !== '') {
                this.setTxtIntro(txtIntroAspect)
            } else {
                this.setTxtIntro(txtIntro)
            }

            this.setTxtIntroAspect(txtIntroAspect)
            this.setTxtIntroCmaj(txtIntro)
        },
        setHasSuggestionOption() {
            let option = undefined
            let exist = false

            this.account.current_contracts.forEach(contract => {
                option = contract.contract_offer.options.find(option => option.code === "MEDIA_SUGGESTION")

                if (option !== undefined) {
                    exist = true
                }
            })

            this.hasSuggestionOption = exist
        },
    },
    computed: {
        ...mapState('account', ['senders','account']),
        ...mapState('createCmaj', ['currentStep', 'emailsValid', 'providers', 'selectedApidaeSelection']),
        aspectLabel() {
            if(this.aspect !== undefined && this.aspect !== '') {
                return aspectElements.find(aspect => {
                    return aspect.name === this.aspect
                }).label
            }
        },
    },
    created() {
        this.resetState()
        this.$store.dispatch('account/fetchContacts')
        this.$store.dispatch('account/fetchCategories')
        this.$store.dispatch('account/fetchCommunes')
        this.getFields()

        this.aspect = this.$route.params.aspect

        this.initDefaultName()
        this.initFirstPartEmail()
        this.initLastPartEmail()
        this.getInternalCriterias()
        this.setHasSuggestionOption()
        this.getAccountIntroTxt()

        this.$store.dispatch('account/loadSenders').then(() => {
            if (this.senders.length) {
                this.setSender(this.senders[0])
            }
        })
    }
}
</script>